module.exports = __webpack_public_path__ + "static/69gde-3814b52128f3d70b06c9f695e5b875b6.gif";